import {Component, Input, OnInit, Renderer2, ViewChild, AfterViewInit} from '@angular/core';
import {EnumerationService} from '../services/enumeration.service';
import {ExcRestService} from 'exc-rest-v2';
import {ExcTranslation} from 'exc-core-v2';
import {IExgTab} from 'exc-tab-v2';
import {IExgEvent} from '../misc/interfaces/IExgEvent';
import {ExgDataListComponent, ExgModalService} from 'exc-controls-v2';
import {ApplicationService} from '../services/application.service';
import {DataService} from '../services/data.service';
import {ExcSecurityService} from 'exc-security-v2';
import {TaskDataService} from '../services/task-data.service';
import { animate, style, transition, trigger } from '@angular/animations';
import {ExgApplicationEventEmitter} from '../misc/classes/ExgApplicationEventEmitter';
import {ExgEventArgs} from '../misc/classes/ExgEventArgs';
import {ICaseSummaryData} from '../misc/interfaces/ICaseSummaryData';

interface Task {
  vorgID: number;
}

interface TaskListModel {
  state: number;
  selected: Task[];
  selectItem: (index: number) => void;
  doubleClick: (index: number) => void;
}

@Component({
  selector: 'app-workflow',
  templateUrl: './workflow.component.html',
  styles: [],
  animations: [
    trigger('slideInOut', [
      transition('void => false', []),
      transition(':enter', [
        style({ transform: 'translateY(-100%)', opacity: 0 }),
        animate('300ms ease-in',
          style({ transform: 'translateY(0)', opacity: 1 })
        )
      ]),
      transition('false => void', []),
      transition(':leave', [
        animate('300ms ease-out',
          style({ transform: 'translateY(-100%)', opacity: 0 })
        )
      ])
    ])
  ]
})
export class WorkflowComponent extends ExcTranslation implements OnInit, IExgTab, AfterViewInit {

  @ViewChild('TaskList', {read: ExgDataListComponent}) dl!: ExgDataListComponent;

  wfConfig = {
    selectedWorkflowIndex: 0,
    isLoading: false,
    isSavedVersion: false
  };

  /*Generell*/
  auID = '';
  Data: any;
  tabinstance: any;
  /*Enum Lists*/
  vorgStateEnumList: any[] = [];
  vorgTypeEnumList: any[] = [];
  vorgSubTypeEnumList: any[] = [];

  // anlagenauswahl
  selectedAttachments: {[dokID: string]: boolean} = {};
  selectedAttachmentsCount = 0;
  caseSummary: ICaseSummaryData | undefined;
  attachmentEvents = new ExgApplicationEventEmitter();

  createTaskConfig = {
    currentStepIndex: 0,
    timeline : [
      {caption: 'Vorgangsanlage', status: 1, iconClass: 'far fa-clipboard-list'},
      {caption: 'Anlagen auswählen', status: 0, iconClass: 'far fa-paperclip'},
      {caption: 'Abschluss', status: 0, iconClass: 'fa-flag-checkered'}
    ],
    disablePrevButton: true,
    disableNextButton: false,
    disableSaveButton: true,
    createTaskInputsDisabled: false,
    createTaskButtonDisabled: false
  };
  /*TaskStack*/
  newTaskStack: any[] = [];
  newTaskListModel: TaskListModel = {
    state: 0,
    selected: [],
    selectItem: (index: number): void => {
      if (index >= 0) {
        this.openCreatedTask(this.newTaskStack[index]);
      }
      this.updateButtonStates();
    },
    doubleClick: (index: number): void => {
      if (this.excSecurity.isFeatured('TASKREAD')) {
        this.appSvc.Task.Workspace.OpenTabV2(this.newTaskStack[index].vorgID);
      }
    }
  };

  constructor(public excRest: ExcRestService,
              public modal: ExgModalService,
              public enumSvc: EnumerationService,
              public appSvc: ApplicationService,
              private dataSvc: DataService,
              private taskDataSvc: TaskDataService,
              public excSecurity: ExcSecurityService) {
    super();
  }
  /*Create Task FORMS*/
  private _selectedVorgangTypEnmIdent = 0;
  private _selectedVorgangTypEnmSelector = '';
  private _selectedVorgangTypIndex = 0;
  private _selectedVorgangSubTypIndex = 0;
  selectedVorgBeschreibung = '';
  private resetForms(): void {
    this._selectedVorgangTypEnmIdent = 0;
    this._selectedVorgangTypEnmSelector = '';
    this._selectedVorgangTypIndex = 0;
    this._selectedVorgangSubTypIndex = 0;
    this.selectedVorgBeschreibung = '';
    this.selectedAttachments = {};
    this.selectedAttachmentsCount = 0;
  }
  get selectedVorgangTypEnmSelector(): string {     return this._selectedVorgangTypEnmSelector;  }
  get selectedVorgangTypIndex(): number       {     return this._selectedVorgangTypIndex;  }
  set selectedVorgangTypIndex(selectedIndex: number) {
    this._selectedVorgangTypEnmIdent = this.vorgTypeEnumList[selectedIndex].enmIdent;
    this._selectedVorgangTypEnmSelector = this.vorgTypeEnumList[selectedIndex].enmSelector;
    this.vorgSubTypeEnumList = this.enumSvc.getEnumerationList(this._selectedVorgangTypEnmSelector);
    this._selectedVorgangTypIndex = selectedIndex;
    this._selectedVorgangSubTypIndex = 0;
  }
  get selectedVorgangSubTypIndex(): number {   return this._selectedVorgangSubTypIndex;  }
  set selectedVorgangSubTypIndex(selectedIndex: number) { this._selectedVorgangSubTypIndex = selectedIndex;  }
  ngOnInit(): void {
    if (this.Data && this.excSecurity.isFeatured('TASKCREATE')) {
      this.auID = this.Data.auID;
      if (this.tabinstance) {
        this.tabinstance.Label = this.getRessource('Label');
      }
      this.getTaskFields();
      this.loadCaseSummary();
    } else {
      this.modal.showToast(this.getRessource('Toasts.NoAuth'), 'md-toast', 'fal fa-ban');
      this.tabinstance.Close();
    }
    this.updateTimelineCaptions();
    this.wfConfig.selectedWorkflowIndex = this.createTaskConfig.currentStepIndex;
    this.registerEvents();
  }
  ngAfterViewInit(): void {
    this.updateButtonStates();
  }
  private loadCaseSummary(): void {
    this.caseSummary = this.dataSvc.Case.Summary.Get(this.Data.auID, undefined, {Events: this.attachmentEvents});
  }

  private registerEvents(): void {
    this.attachmentEvents.Case?.Summary?.DataLoaded?.subscribe((evt: ExgEventArgs) => {
    });
  }

  private getTaskFields(): void {
    this.vorgStateEnumList = this.enumSvc.getEnumerationList('VorgangStatus');
    this.vorgTypeEnumList = this.enumSvc.getEnumerationList('VorgangTyp');
  }
  /*WORKFLOW Controls*/

  clickedPrev(): void {
    if (this.createTaskConfig.currentStepIndex > 0) {
      this.createTaskConfig.currentStepIndex -= 1;
    }
    this.updateButtonStates();
  }

  clickedNext(): void {
    if (this.createTaskConfig.currentStepIndex < 2) {
      this.createTaskConfig.currentStepIndex += 1;
    }
    this.updateButtonStates();
  }

  completeCurrentStep(stepIndex: number): void {
    if (stepIndex === 2) {
      if (this.selectedAttachmentsCount > 0) {
        this.copySelectedAttachmentsToTask();
      }
      this.createTaskConfig.timeline[stepIndex].status = 2;
      this.updateButtonStates();
    }else if (stepIndex === 3){
      this.createTaskConfig.timeline[stepIndex].status = 2;
      this.updateButtonStates();
    } else if (stepIndex === 1) {
      if (this.checkCurrentStepCompletion(stepIndex)) {
        this.createTaskConfig.timeline[stepIndex].status = 2;
        this.updateButtonStates();
      }
    }
  }

  checkCurrentStepCompletion(currentStepIndex: any): boolean {
    // todo: Logic for Step checking
    return true;
  }

  updateButtonStates(): void {
    this.createTaskConfig.disablePrevButton = this.createTaskConfig.currentStepIndex === 0;

    if (this.createTaskConfig.currentStepIndex === 0) {
      // next > nur wenn ein vorgang angelegt wurde
      const hasSelectedTask = this.newTaskStack.length > 0 &&
        this.dl &&
        this.dl.selectedRow !== null &&
        this.dl.selectedRow !== undefined &&
        this.dl.selectedRow >= 0;

      this.createTaskConfig.disableNextButton = !hasSelectedTask;

      // vorgang erstellt aber nicht ausgewählt -> vogang anlegen button reaktivieren
      if (this.newTaskStack.length > 0 && (!this.dl || this.dl.selectedRow === -1)) {
        this.createTaskConfig.createTaskInputsDisabled = false;
        this.createTaskConfig.createTaskButtonDisabled = false;
      }
    } else if (this.createTaskConfig.currentStepIndex === 1) {
      // skip button nur enabled, wenn ein vorgang ausgewählt ist
      const hasSelectedTask = this.dl &&
        this.dl.selectedRow !== null &&
        this.dl.selectedRow !== undefined &&
        this.dl.selectedRow >= 0;

      this.createTaskConfig.disableNextButton = !hasSelectedTask;
    } else {
      this.createTaskConfig.disableNextButton = this.createTaskConfig.currentStepIndex === 2;
    }

    this.createTaskConfig.timeline.forEach((step, index) => {
      if (index < this.createTaskConfig.currentStepIndex) {
        step.status = 2; //completed
      } else if (index === this.createTaskConfig.currentStepIndex) {
        step.status = 1; // in progress
      } else {
        step.status = 0; // pending
      }
    });
  }
  createTask(): void {
    if (this.excSecurity.isFeatured('TASKCREATE')) {
      const newTask = this.getCreateTaskModel();
      this.excRest.post(
        this.excRest.computeUrl('TaskC', {})
        , newTask).subscribe(ret => {
        if (ret?.success && ret?.data) {
          this.createTaskConfig.createTaskInputsDisabled = true;
          this.createTaskConfig.createTaskButtonDisabled = true;
          this.completeCurrentStep(this.createTaskConfig.currentStepIndex);
          this.shelveSuccessfulTask(ret.data.Vorgang);
        }
      });
    }
  }

  private getCreateTaskModel(): any {
    /*If no Enumlist for Subtype SubType EnmIdent = 0*/
    if (this.selectedVorgangTypEnmSelector === '') {
      return {
        vorg_auID: this.Data.auID,
        vorg_enmIdent_VorgangTyp: this.vorgTypeEnumList[this.selectedVorgangTypIndex].enmIdent,
        vorg_enmName_VorgangTyp: 'VorgangStatus',
        vorg_enmIdent_VorgangStatus: 1,
        vorgBeschreibung: this.selectedVorgBeschreibung,
        vorgVorgangSubTyp_enmIdent: 0,
        vorgVorgangSubTyp_enmName: this.selectedVorgangTypEnmSelector,
        linkedID: this.Data.linkedID
      };
    }
    else {
      return {
        vorg_auID: this.Data.auID,
        vorg_enmIdent_VorgangTyp: this.vorgTypeEnumList[this.selectedVorgangTypIndex].enmIdent,
        vorg_enmName_VorgangTyp: 'VorgangStatus',
        vorg_enmIdent_VorgangStatus: 1,
        vorgBeschreibung: this.selectedVorgBeschreibung,
        vorgVorgangSubTyp_enmIdent: this.vorgSubTypeEnumList[this.selectedVorgangSubTypIndex].enmIdent,
        vorgVorgangSubTyp_enmName: this.selectedVorgangTypEnmSelector,
        linkedID: this.Data.linkedID
      };
    }
  }
  isAttachmentAlreadyCopied(dokID: string): boolean {
    return this.newTaskStack[this.dl?.selectedRow]?.attachments?.[dokID] === true;
  }

  onAttachmentSelection(dokID: string, selected: boolean): void {
    if (this.isAttachmentAlreadyCopied(dokID)) {
      this.selectedAttachments[dokID] = true;
      return;
    }
    this.selectedAttachments[dokID] = selected;
    this.selectedAttachmentsCount = Object.keys(this.selectedAttachments)
      .filter(i => this.selectedAttachments[i] && !this.isAttachmentAlreadyCopied(i)).length;
  }
  getAttachmentCount(task: any): number {
    if (!task?.attachments) {
      return 0;
    }
    return Object.keys(task.attachments).filter(i => task.attachments[i]).length;
  }
  copySelectedAttachmentsToTask(): void {
    const selectedTask = this.newTaskStack[this.dl.selectedRow];
    if (!selectedTask || this.selectedAttachmentsCount === 0) {
      return;
    }

    const dokIDs = Object.keys(this.selectedAttachments)
      .filter(dokID => this.selectedAttachments[dokID] && !this.isAttachmentAlreadyCopied(dokID))
      .map(dokID => ({dokID}));

    const dataObject = {
      selectionObjects: dokIDs.map(item => ({
        dokID: item.dokID,
        objID: selectedTask.vorgID
      }))
    };

    this.excRest.post(
      this.excRest.computeUrl('DocumentCloneC', {}),
      dataObject
    ).subscribe((returnValue: any) => {
      if (returnValue && returnValue.success) {
        this.modal.showToast(
          `${dokIDs.length} Dokumente in Vorgang kopiert`,
          'md-toast bg-green',
          'far fa-copy'
        );
        selectedTask.attachments = JSON.parse(JSON.stringify(this.selectedAttachments));
        this.selectedAttachmentsCount = Object.keys(this.selectedAttachments)
          .filter(i => this.selectedAttachments[i] && !this.isAttachmentAlreadyCopied(i))
          .length;

      } else {
        this.modal.showToast(
          'Fehler beim Kopieren der Dokumente',
          'md-toast bg-red',
          'far fa-exclamation'
        );
      }
    });
  }

  private shelveSuccessfulTask(Vorgang: any): void {
    Vorgang.config = JSON.parse(JSON.stringify(this.createTaskConfig));
    Vorgang.form = {
      selectedVorgangTypEnmIdent    : this._selectedVorgangTypEnmIdent,
      selectedVorgangTypEnmSelector : this._selectedVorgangTypEnmSelector,
      selectedVorgangTypIndex       : this._selectedVorgangTypIndex,
      selectedVorgangSubTypIndex    : this._selectedVorgangSubTypIndex,
      selectedVorgBeschreibung      : this.selectedVorgBeschreibung,
    };
    Vorgang.attachments = JSON.parse(JSON.stringify(this.selectedAttachments));

    this.newTaskStack.push(Vorgang);
    this.dl.selectedRow = this.newTaskStack.indexOf(Vorgang);

    this.updateButtonStates();
  }

  startNewCreationCycle(): void {
    if (this.dl) {
      this.dl.selectedRow = -1;
    }
    this.createTaskConfig.currentStepIndex = 0;

    this.resetForms();
    this.createTaskConfig.createTaskInputsDisabled = false;
    this.createTaskConfig.createTaskButtonDisabled = false;

    this.updateButtonStates();
  }
  private openCreatedTask(Vorgang: any): void {
    const currentStep = this.createTaskConfig.currentStepIndex;

    this.createTaskConfig = JSON.parse(JSON.stringify(Vorgang.config));
    this.createTaskConfig.currentStepIndex = currentStep;

    this._selectedVorgangTypEnmIdent    = Vorgang.form.selectedVorgangTypEnmIdent;
    this._selectedVorgangTypEnmSelector = Vorgang.form.selectedVorgangTypEnmSelector;
    this._selectedVorgangTypIndex       = Vorgang.form.selectedVorgangTypIndex;
    this._selectedVorgangSubTypIndex    = Vorgang.form.selectedVorgangSubTypIndex;
    this.selectedVorgBeschreibung       = Vorgang.form.selectedVorgBeschreibung;

    if (Vorgang.attachments) {
      this.selectedAttachments = JSON.parse(JSON.stringify(Vorgang.attachments));
      this.selectedAttachmentsCount = Object.keys(this.selectedAttachments)
        .filter(i => this.selectedAttachments[i] && !this.isAttachmentAlreadyCopied(i))
        .length;
    } else
    {
      this.selectedAttachments = {};
      this.selectedAttachmentsCount = 0;
    }

    this.createTaskConfig.createTaskInputsDisabled = true;
    this.createTaskConfig.createTaskButtonDisabled = true;

    this.updateButtonStates();
  }
  // getAttachmentCount(attachments: any): number {
  //   if (!attachments) {
  //     return 0;
  //   }
  //   let count = 0;
  //   for (const i in attachments) {
  //     if (attachments[i]) {
  //       count++;
  //     }
  //   }
  //   return count;
  // }

  private updateTimelineCaptions(): void {
    this.createTaskConfig.timeline = [
      {caption: 'Vorgangsanlage', status: 1, iconClass: 'far fa-clipboard-list'},
      {caption: 'Anlagen auswählen', status: 0, iconClass: 'far fa-paperclip'},
      {caption: 'Abschluss', status: 0, iconClass: 'fa-flag-checkered'}
    ];
  }
}
